<template>
    <footer class="footer">
        <div class="w1200">
            <div class="link-box">
                <router-link to="" class="link-btn"><span>Copyright©2023 版权所有</span></router-link>
                <router-link to="" class="link-btn"><span>开发者：海南光年之旅科技有限公司</span></router-link>
                <router-link to="" class="link-btn"><span @click="openG()">粤ICP备2022096970号</span></router-link>
                <router-link :to="{ path: '/about', query: { id: 3 } }" class="link-btn"><span>隐私协议</span></router-link>
                <router-link :to="{ path: '/about', query: { id: 2 } }" class="link-btn"><span>用户协议</span></router-link>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        components: {},
        data() {
            // 这里存放数据
            return {
                aList: [],
            };
        },
        created() {},
        mounted() {
        },
        // 监听属性 类似于data概念
        computed: {},
        // 方法集合
        methods: {
            openG() {
                window.open("//beian.miit.gov.cn/#/Integrated/recordQuery");
            },
        },
    };
</script>
<style scoped lang="less">
    .footer {
        background: #f5f5f5;
        text-align: center;

        .other {
            padding: 30px 0;
            display: flex;
            align-items: center;
            justify-content: space-around;
            border-bottom: 1px solid #ddd;

            .left-box {
                display: flex;
                color: #aaa;

                // width: 50%;
                .list {
                    // margin-right: 30px;
                }
            }
        }

        .tip {
            margin-top: 20px;

            p {
                color: #bbb;
                margin-bottom: 7px;
            }
        }

        .link-btn {
            padding: 10px;
            display: inline-block;
        }

        .xieyi-ul {
            text-align: left;

            .xy-title {
                font-weight: normal;
                font-size: 20px;
                margin-bottom: 10px;
            }

            .link-btn {
                padding: 10px 0;
                color: #aaa;
            }
        }
    }

    /* 移动端 */
    @media (max-width: 600px) {
        .footer {
            .other {
                display: block;

                .left-box {
                    width: 100%;
                    justify-content: center;

                    .list {
                        margin: 0 10px;
                    }
                }
            }

            .xieyi-ul {
                margin-top: 30px;
                text-align: center;
            }
        }
    }

    .app-box {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        padding: 10px;
        margin-bottom: 10px;

        .img {
            width: 35px;
            height: 35px;
            border-radius: 7px;
            position: absolute;
            background: #fff;
        }
    }
</style>